import React from 'react';
import {TabView} from '../../../components/tab/TabView';
import {
  CarouselAdActiveTable,
  CarouselAdCompletedTable,
} from './CarouselAdTable';
import {SearchFilter} from '../../../components/filter/Filters';
import {useFilter} from '../../../controllers/useFilter';

export const CarouselAdTabView = props => {
  const {route: {params} = {}} = props;
  const {onChangeFilter, searchValue} = useFilter({});

  let tabs = {
    active: {
      label: 'Active',
      view: <CarouselAdActiveTable searchValue={searchValue} />,
    },
    completed: {
      label: 'Completed',
      view: <CarouselAdCompletedTable searchValue={searchValue} />,
    },
  };

  return (
    <TabView
      tabs={tabs}
      params={params}
      {...props}
      actions={[
        <SearchFilter
          value={searchValue}
          onChangeFilter={onChangeFilter}
          placeholder="Search"
        />,
      ]}
    />
  );
};
